import { reactive, readonly } from 'vue'

const defaultContext = () => ({
  scene: 'team',
  payload: {},
})

const state = reactive({
  show: false,
  context: defaultContext(),
})

export function openShare(scene, payload = {}) {
  state.context = {
    scene: scene || 'team',
    payload: payload || {},
  }
  state.show = true
}

export function closeShare() {
  state.show = false
}

export function useShareState() {
  return readonly(state)
}
